module.exports = __webpack_public_path__ + "static/img/bathroom-thumb.f2fe1b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/bathroom-thumb.jpg
// module id = Ybiw
// module chunks = 0